var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53751 12C1.53751 11.8011 1.6185 11.6103 1.76267 11.4696C1.90684 11.329 2.10237 11.25 2.30626 11.25H20.438L15.5995 6.53097C15.4551 6.39014 15.374 6.19913 15.374 5.99997C15.374 5.80081 15.4551 5.6098 15.5995 5.46897C15.7438 5.32814 15.9396 5.24902 16.1438 5.24902C16.3479 5.24902 16.5437 5.32814 16.688 5.46897L22.838 11.469C22.9096 11.5386 22.9664 11.6214 23.0052 11.7125C23.0439 11.8036 23.0639 11.9013 23.0639 12C23.0639 12.0986 23.0439 12.1963 23.0052 12.2874C22.9664 12.3785 22.9096 12.4613 22.838 12.531L16.688 18.531C16.5437 18.6718 16.3479 18.7509 16.1438 18.7509C15.9396 18.7509 15.7438 18.6718 15.5995 18.531C15.4551 18.3901 15.374 18.1991 15.374 18C15.374 17.8008 15.4551 17.6098 15.5995 17.469L20.438 12.75H2.30626C2.10237 12.75 1.90684 12.671 1.76267 12.5303C1.6185 12.3896 1.53751 12.1989 1.53751 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.8ce7a1bf5d45f8b6bcd2af3d54f04fdd.svg";
export { ForwardRef as ReactComponent };